import React from "react";

const HomePage = () => (
  <div>
    Bienvenido a tu nueva contabilidad
  </div>
)

export default HomePage;
